var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUndefinedRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1939",
    className: "background",
    y: 0,
    width: 19,
    height: 19,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4734",
    className: "question-mark",
    d: "M9.2,9.6c.3-.5.8-.8,1.1-1.3.3-.4.2-.9-.2-1.2-.2-.1-.4-.2-.6-.2-.5,0-.9.4-1.1.9l-1-.4c.3-.9,1.1-1.5,2-1.5.7,0,1.4.3,1.8.9.3.6.3,1.2,0,1.8-.4.7-.9.9-1.1,1.3,0,.2-.1.3-.1.8h-1.1c0-.4,0-.8.2-1.2ZM10.2,12.3c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7c.4,0,.7.3.7.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUndefinedRegular);
export default __webpack_public_path__ + "static/media/file-undefined-regular.aa7214803e34f4399f88a977335d0993.svg";
export { ForwardRef as ReactComponent };